import React from 'react';
import styled from 'styled-components';

interface ISSkeletonPulseProps {
  height?: string;
  width?: string;
  translucent?: boolean;
  background?: string;
}

const SSkeletonPulse = styled.div < ISSkeletonPulseProps >`
  display: inline-block;
  height: ${({ height }): string => (height || '16px')};
  width: ${({ width }): string => (width || '100%')};
  background: ${({ background }): string => background};
  background-size: 400% 400%;
  animation: pulse 1.2s ease-in-out infinite;
  @keyframes pulse {
    0% {
      background-position: 0% 0%;
    }
    100% {
      background-position: -135% 0%;
    }
  }
`;

export const SSkeletonLine = styled(SSkeletonPulse)`
  &::before {
    content: "\00a0";
  }
`;

interface ISkeletonLineProps extends ISSkeletonPulseProps {
  className?: string;
  height?: string;
  width?: string;
  translucent?: boolean;
}

const SkeletonLine: React.FunctionComponent<ISkeletonLineProps> = (
  {
    className, height, width, translucent,
  },
) => {
  const background = translucent
    ? 'linear-gradient(-90deg, #C1C1C1 0%, #F8F8F8 50%, #C1C1C1 100%)'
    : 'linear-gradient(-90deg, #F0F0F0 0%, #F8F8F8 50%, #F0F0F0 100%)';
  return (
    <SSkeletonLine
      height={height}
      width={width}
      translucent={translucent}
      className={className}
      background={background}
    />
  );
};

SkeletonLine.defaultProps = {
  className: 'acac-skeleton-line',
  height: '16px',
  translucent: true,
  width: '100%',
};

export default SkeletonLine;
